import convertToOrdinal from '@/utils/number/toOrdinalNumbers';
import { TickCircleWrapper } from './helper';
import { Check, ChevronRight, Lock } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import useTheme from '@/theme/useTheme';
import { formatMoneyByCurrency } from '@/utils';

const CircleProgress: React.FC<{
  wagerRequired: number;
  currentWagered: number;
  claimedIndex: number;
  circleCount?: number;
}> = (props) => {
  const {
    wagerRequired,
    currentWagered,
    // ongoingIndex,
    claimedIndex,
    circleCount = 10,
  } = props;
  const { theme } = useTheme();

  const ongoingIndex =
    currentWagered >= wagerRequired
      ? circleCount
      : (currentWagered - (currentWagered % (wagerRequired / circleCount))) /
        (wagerRequired / circleCount);


  return (
    <>
      {Array.from({ length: circleCount }).map((_, idx) => {
        const currentBet =
          currentWagered >= wagerRequired
            ? wagerRequired / circleCount
            : Number(currentWagered) % (wagerRequired / circleCount);

        const content = (
          <TickCircleWrapper
            sx={{
              border:
                idx <= ongoingIndex
                  ? `1px solid ${theme.palette.success.main}`
                  : undefined,
              background:
                idx > claimedIndex && idx < ongoingIndex
                  ? theme.palette.success.main
                  : idx < ongoingIndex
                    ? 'transparent'
                    : idx === ongoingIndex
                      ? `conic-gradient(${theme.palette.success.main} ${(currentBet / (wagerRequired / circleCount)) * 100}%, 0, transparent 66%)`
                      : theme.palette.grey[600],
            }}
          >
            {idx > claimedIndex && idx <= ongoingIndex ? (
              `${convertToOrdinal(idx + 1)}`
            ) : idx < ongoingIndex ? (
              <Check color="success"></Check>
            ) : (
              <Lock color="disabled"></Lock>
            )}
          </TickCircleWrapper>
        );

        if (idx === ongoingIndex) {
          return (
            <Tooltip
              key={idx}
              title={`${formatMoneyByCurrency(currentBet, {
                withCurrencySymbol: true,
              })} / ${formatMoneyByCurrency(wagerRequired / circleCount, {
                withCurrencySymbol: true,
              })} wagered`}
            >
              {content}
            </Tooltip>
          );
        } else {
          return content;
        }
      })}
    </>
  );
};

export default CircleProgress;
